import appbase from 'hobbit-base/components/appbase/index.vue';
import agentNotice from 'hobbit-engine-base/components/agentNotice/agentNotice.vue';
import faqimbtn from 'hobbit-engine-base/components/faqimbtn/faqimbtn.vue';

export default {
  name: 'app',
  data() {
    return {
      faqIMBtnEnable: false,
      agentNoticeVisible: false,
    };
  },
  computed: {
    disableIMRoutes() {
      return (
        this.$config.custom.disableIMRoutes[this.$ctx.view]
        || this.$config.custom.disableIMRoutes.pc
      );
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    route(to, from) {
      // 指定路由或App中禁用IM
      this.faqIMBtnEnable = (to.name && !this.disableIMRoutes.includes(to.name)) && !this.$ctx.isApp();
      this.agentNoticeVisible = true;
    },
  },
  components: {
    appbase,
    faqimbtn,
    agentNotice,
  },
};
